export default "__VITE_ASSET__CxX7T6mK__"